

























































import store from '@/store'
import ApiClient from '@/js/api.js'
import ManageTemplate from '@/views/templates/ManageTemplate.vue'
import ManageRow from '@/views/organisms/ManageRow.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import ErrorLabel from '@/views/atoms/ErrorLabel.vue'
import Zipcode from '@/views/molecules/Zipcode.vue'
import SelectBox from '@/views/atoms/SelectBox.vue'
import YellowButton from '@/views/atoms/YellowButton.vue'
import BackButton from '@/views/atoms/BackButton.vue'
import Global from '@/js/global.js'


export default
  name: 'Append'

  components: {
    ManageTemplate
    ManageRow
    TextBox
    ErrorLabel
    Zipcode
    SelectBox
    YellowButton
    BackButton
  }

  data: () ->
    prefList: {}
    prefID: '1'
    genderID: ''
    prefValue: ''
    loginCheck: false
    defaultValue: {}
    genderList: Global.getGender()
    mail: ''
    url: '/user/append'
    confirmError: ''

  created: () ->
    @prefID = store.getters.getPostParam.prefecture_id
    @genderID = store.getters.getPostParam.gender
    @prefList = await store.getters.prefList
    @loginCheck = await store.getters.isLogin
    if @loginCheck
      @url = '/user/edit'

    if @loginCheck
      api = new ApiClient()
      data = await api.get('/member/user/detail')
      if data.detail.age == '0'
        data.detail.age = ''
      @defaultValue = data.detail
      @prefID = data.detail.prefecture_id
      @genderID = data.detail.gender
      @prefValue = data.detail.address

  methods: {
    search_address: (address) ->
      @prefID = address.pref_id + ''
      @prefValue = address.shiku_name + address.choiki_name
      store.dispatch('setPostParam', {label: "prefecture_id", value: @prefID, index: null, group: null})
    confirm_send: (e) ->
      @confirmError = ''
      console.log store.getters.getPostParam
      api = new ApiClient()
      data = await api.post('/member/user/confirm')
      mailFlag = true
      if store.getters.getPostParam.mailaddress != store.getters.getPostParam.mailaddress_confirm
        data.errors.mailaddress_confirm = ['メールアドレスが一致しません']
        mailFlag = false
        @confirmError = 'メールアドレスが一致しません'
      store.dispatch('setErrors', data.errors)
      if data.errors.length == 0 && mailFlag
        @$router.push '/user/confirm'
      window.scrollTo(0, 0)
    go_back: (e) ->
      @$emit('go_back')
  }
